/* eslint-disable react/jsx-max-props-per-line */
/* eslint-disable react/jsx-sort-props */
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { TableCell } from '@mui/material';
import moment from 'moment';
import * as actionsEquipamentos from '../../../store/equipamento/actions';
import * as selectorsAuth from '../../../store/auth/reducer';
import * as selectorsEquipamentos from '../../../store/equipamento/reducer';
import * as Role from '../../../constants/role';
import { getMaxColumnLength } from '../../../utils';
import { TableWidgetV2 } from '../../../components/v2';
import HistoricoEquipamentosModal from './HistoricoEquipamentosModal';
import { ordernarPorDataHistorico, tipoHistoricoNome } from './helpers';

const HistoricoTab = ({ idEquipamento, historico, userRole, deleteHistoricoEquipamento }) => {
  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);
  const [historicoEquipamentoId, setHistoricoEquipamentoId] = useState(null);

  const isAdmin = () => Role.ADMIN === userRole || Role.SUPER_ADMIN === userRole;

  const renderRows = (h) => (
    <>
      <TableCell>{moment(h.dataHistorico).format('DD/MM/YYYY')}</TableCell>
      <TableCell>{tipoHistoricoNome(h.tipoHistorico)}</TableCell>
      <TableCell size="medium" title={h.observacao}>
        {getMaxColumnLength(h.observacao)}
      </TableCell>
    </>
  );

  const onDelete = (rowId) => {
    deleteHistoricoEquipamento(rowId, () => {
      setRows([...rows.filter((s) => s.id !== rowId)]);
    });
  };

  const onEdit = (rowId) => {
    setHistoricoEquipamentoId(rowId);
    setOpen(true);
  };

  const onAdd = () => {
    setHistoricoEquipamentoId(null);
    setOpen(true);
  };

  const afterSave = (data) => {
    setRows([...rows.filter((s) => s.id !== data.id), data].sort(ordernarPorDataHistorico));
  };

  useEffect(() => {
    setRows(historico || []);
  }, [historico]);

  return (
    <>
      <TableWidgetV2
        rows={rows}
        titles={['Data', 'Tipo', 'Descrição']}
        deleteMessage="A informação será removido e não poderá ser mais recuperado."
        renderRows={renderRows}
        onEdit={onEdit}
        onDelete={onDelete}
        onAdd={onAdd}
        hasRowActions={isAdmin()}
        hasAdd={isAdmin()}
      />
      <HistoricoEquipamentosModal
        open={open}
        onClose={() => {
          setHistoricoEquipamentoId(null);
          setOpen(false);
        }}
        idEquipamento={idEquipamento}
        id={historicoEquipamentoId}
        afterSave={afterSave}
      />
    </>
  );
};

HistoricoTab.propTypes = {
  idEquipamento: PropTypes.string,
  historico: PropTypes.array,
  userRole: PropTypes.string,
  deleteHistoricoEquipamento: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  userRole: selectorsAuth.getRole(state),
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  ...actionsEquipamentos,
  ...selectorsEquipamentos,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(HistoricoTab);
